import { useSearchParams } from 'react-router-dom'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { PageHelpPopover } from '@/components/common/PageHelpPopover'
import { IncomeTab } from '@/components/accounting/IncomeTab'
import { TaxSettingsTab } from '@/components/accounting/TaxSettingsTab'
import { ExpensesTab } from '@/components/accounting/ExpensesTab'
import { SummaryTab } from '@/components/accounting/SummaryTab'
import 'dayjs/locale/ru'
import 'dayjs/locale/en'

const TABS = ['income', 'taxes', 'expenses', 'summary'] as const
type AccountingTab = (typeof TABS)[number]

export function AccountingPage() {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get('tab') ?? ''
  const tab: AccountingTab = (TABS as readonly string[]).includes(raw) ? (raw as AccountingTab) : 'income'

  return (
    <DashboardLayout>
      <Box sx={{ p: 3, pt: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 2 }}>
          <Typography variant="h4" component="h1" fontWeight={700}>
            {t('accounting.title', 'Бухгалтерия')}
          </Typography>
          <PageHelpPopover pageKey="accounting" />
        </Box>

        <Tabs
          value={tab}
          onChange={(_, value: string) => setSearchParams({ tab: value })}
          sx={{ mb: 3 }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab value="income" label={t('accounting.tabs.income', 'Доходы')} />
          <Tab value="taxes" label={t('accounting.tabs.taxes', 'Налоги')} />
          <Tab value="expenses" label={t('accounting.tabs.expenses', 'Расходы')} />
          <Tab value="summary" label={t('accounting.tabs.summary', 'Сводка')} />
        </Tabs>

        {tab === 'income' && <IncomeTab />}
        {tab === 'taxes' && <TaxSettingsTab />}
        {tab === 'expenses' && <ExpensesTab />}
        {tab === 'summary' && <SummaryTab />}
      </Box>
    </DashboardLayout>
  )
}
